import { useMemo } from "react";
import ValidationError from "../../ZodError";
import { TransitionProgress } from "../schemas/TransitionProgressSchemas";
import { calculateTransitionProgress } from "../utils/transitionProgressCalculator";
import useTransitionTasks from "./useTransitionTasks";
const useTransitionProgress = (transitionId, auth) => {
    const tasksQuery = useTransitionTasks(transitionId, auth);
    const processedData = useMemo(() => {
        if (!tasksQuery.data) {
            return undefined;
        }
        try {
            const rawData = calculateTransitionProgress(tasksQuery.data.transitionTaskId, tasksQuery.data.level1Tasks, tasksQuery.data.level2Tasks);
            const validationResult = TransitionProgress.safeParse(rawData);
            if (validationResult.success) {
                return validationResult.data;
            }
            else {
                console.error("TransitionProgress validation failed:", validationResult.error);
                throw new ValidationError("Invalid transition progress data", validationResult.error.issues);
            }
        }
        catch (error) {
            console.error("Error calculating transition progress:", error);
            return undefined;
        }
    }, [tasksQuery.data]);
    if (tasksQuery.hasError) {
        return {
            data: undefined,
            isLoading: false,
            hasError: true,
            error: tasksQuery.error,
        };
    }
    if (tasksQuery.isLoading) {
        return {
            data: undefined,
            isLoading: true,
            hasError: false,
        };
    }
    if (processedData !== undefined) {
        return {
            data: processedData,
            isLoading: false,
            hasError: false,
        };
    }
    return {
        data: undefined,
        isLoading: false,
        hasError: true,
        error: new Error("Unable to calculate transition progress"),
    };
};
export default useTransitionProgress;
//# sourceMappingURL=useTransitionProgress.js.map